/**
 * @Author: wuyang
 * @Date: 2024/1/10
 * @Description: "最左边导航栏"
 */
import { useContext, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { EBizPhone, TBizPhone } from '@/types/bizPhone'
import { ContextNav } from '@/layout/base/taskNavStory'
import { useTaskListService } from '@/common/services/task-list/taskListContext'
export const BizPhotoNav = () => {
	const navigate = useNavigate()

	const taskList = useTaskListService()

	const nowTaskType: any = useContext(ContextNav)
	const { taskType, setTasktype, taskGreat, setTaskGreat, setA, a } = nowTaskType

	const navs = useMemo(() => {
		return [
			{
				title: '真人图',
				id: EBizPhone.real
			},
			{
				title: '人台图',
				id: EBizPhone.mannequin
			},
			// {
			// 	title: '商品图',
			// 	id: EBizPhone.goods
			// },
			// {
			// 	title: '假发图',
			// 	id: EBizPhone.wig
			// },
			// {
			// 	title: '纹理图',
			// 	id: EBizPhone.texture
			// },
			{
				title: '白板图',
				id: EBizPhone.tabularasa
			},
			{
				title: '香蕉Pro',
				id: EBizPhone.banana
			},
			{
				title: 'AI模特',
				id: EBizPhone.aiModel,
			},
			{
				title: '姿势裂变',
				id: EBizPhone.postureFission
			},
			{
				title: '商品换色',
				id: EBizPhone.colorChange
			},
		]
	}, [])

	//枚举 用来匹配对应img的src
	const activeNav = useMemo(() => {
		console.log(taskList, 'taskList');

		return navs.find((nav) => taskList.type === nav.id)
	}, [taskList.type, navs])



	// id 用于百度统计
	return (
		// <div className={'w-[76px] border-r-[1px] border-normal min-w-[76px]'}>
		<div className={'border-r-[1px] border-normal min-w-[156px] h-[calc(100vh-102px)] overflow-y-scroll scrollbar-container scrollbar-hide'}>
			<div className={'text-center'}>
				{navs.map((nav) => {
					const path = EBizPhone[nav.id] as TBizPhone
					console.log(path, 'path');
					return (
						<div
							className={`mt-[14px] flex p-[8px] flex-col items-center cursor-pointer ${activeNav?.id === nav.id ? 'active-nav-bg' : ''}`}
							key={nav.id}
							id={`__buz_phone_type_${nav.id}__`}
							onClick={() => {
								setTimeout(() => {
									if (taskGreat === false) {
										navigate(`../${path}/collect`)
									} else {
										navigate(`../${path}/collect`)
										//alert("正在创建任务,请稍后111")
									}
								}, 200);

							}}
						>
							<img
								className={'w-[48px] h-[48px] rounded-full overflow-hidden'}
								src={
									require(`@/asset/icon/${path}-active.png`)
									// activeNav?.id === nav.id
									// 	? require(`@/asset/icon/${path}-active.png`)
									// 	: require(`@/asset/icon/${path}.png`)
								}
								alt=""
							/>
							<div className={'text-normal mt-[6px] text-[12px] nav-tit'}>
								{nav.title}
							</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}
